const features = [
  {
    icon: 'ri-speed-up-fill',
    title: '极速播放',
    desc: '智能 CDN 加速，多线路自动切换，播放流畅不卡顿，拒绝转圈等待。',
  },
  {
    icon: 'ri-4k-fill',
    title: '高清画质',
    desc: '支持 1080P 与 4K 超清，根据网速智能适配，不错过每一帧细节。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '资源库实时同步，新片热剧第一时间上线，追剧永不断档。',
  },
  {
    icon: 'ri-device-line',
    title: '全端适配',
    desc: '电脑、平板、手机无缝切换，躺沙发还是挤地铁，随时随地开看。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净体验',
    desc: '无弹窗广告、无强制注册、无套路收费，回归观影本质。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            平台优势
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-lg p-5 border border-background-200/60 hover:border-accent-500/30 transition-colors text-center"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-accent-500/10 text-accent-500 flex items-center justify-center mx-auto mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                <i className={`${feat.icon} text-xl md:text-2xl`}></i>
              </span>
              <h3 className="text-foreground-900 font-heading text-sm md:text-base font-bold mb-2">
                {feat.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}